/** Entrada de busqueda reutilizable para listas. */
import { clsx } from 'clsx';
import { forwardRef, useId } from 'react';
import { MobileIcon } from './MobileIcon';

type SearchInputProps = {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string;
  id?: string;
};

export const SearchInput = forwardRef<HTMLInputElement, SearchInputProps>(
  ({ value, onChange, placeholder = 'Buscar...', className, id }, ref) => {
    const autoId = useId();
    const inputId = id ?? autoId;
    return (
      <div className={clsx('relative flex items-center', className)}>
        <label htmlFor={inputId} className="sr-only">
          {placeholder}
        </label>
        <span className="pointer-events-none absolute left-4 flex h-6 w-6 items-center justify-center text-text-tertiary">
          <MobileIcon name="search" className="h-5 w-5" />
        </span>
        <input
          ref={ref}
          id={inputId}
          type="search"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          aria-label={placeholder}
          className={clsx(
            'h-12 w-full rounded-full border border-border-light bg-white pl-12 shadow-card',
            value ? 'pr-12' : 'pr-4',
            'truncate text-base text-text-primary placeholder:text-text-tertiary',
            'focus:outline-none focus:border-primary focus:shadow-sm',
            'transition-all duration-200',
          )}
        />
        {value && (
          <button
            type="button"
            onClick={() => onChange('')}
            className="absolute right-1 flex h-11 w-11 items-center justify-center rounded-full hover:bg-bg-tertiary"
            aria-label="Limpiar búsqueda"
          >
            <MobileIcon name="close" className="h-5 w-5 text-text-tertiary" />
          </button>
        )}
      </div>
    );
  },
);

SearchInput.displayName = 'SearchInput';
